/**
 * A row on the plan is a rain event inspection when the rain trigger put it
 * there (`rainfall`) or a visit was filed as weekly + rain event (`both`).
 * Jim 2026-10-05: his three sat on Monday's list looking like any other
 * visit, so he read the dashboard as not showing them.
 */
export function isRainVisit(
  inspectionType: string | null | undefined
): boolean {
  return inspectionType === 'rainfall' || inspectionType === 'both';
}
